import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactUsService } from '../core/services/contact-us.service';
import { LanguageService } from '../core/services/language.service';

@Component({
  selector: 'app-other',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './other.component.html',
  styleUrl: './other.component.css'
})
export class OtherComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  form: FormGroup;

  constructor(private fb: FormBuilder, private contactUsService: ContactUsService, private languageService: LanguageService) {}

  get labels() { return this.contactUsService.commonLabels; }
  get placeholders() { return this.contactUsService.placeholderTextLabels; }
  get messages() { return this.contactUsService.messageLabels; }

  ngOnInit() {
    const lang = this.languageService.getLanguageFromUrl();

    this.form = this.fb.group({
      region: [lang === 'fr-fr' ? 'FR' : lang === 'en-us' ? 'US' : 'INT'],
      description: ['', [Validators.required, Validators.minLength(20)]]
    });

    this.formReady.emit(this.form);
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }
}
